export default "__VITE_ASSET__HKyb94cW__"